import React from 'react'
import { connect } from 'react-redux'
import Modal from 'react-modal'
import Ink from 'react-ink'
import { hideAddBalanceToTicketModal } from '../actions/modalActions'
import { getTranslation } from '../../actions/dataActions'
import { clearCustomer, fastPayment } from '../../actions/receiptActions'
import * as properties from '../../constants/Properties'
import * as resource from '../../constants/Resources'
import ScanTicket from '../../components/ScanTicket'
import { clearKeyboard } from '../../actions/layoutActions'

const AddBalanceToTicketModal = props => {
    const {
        clearCustomer,
        clearKeyboard,
        customer,
        addBalanceToTicketModal,
        getTranslation,
        hideAddBalanceToTicketModal,
        fastPayment
    } = props;

    const amount = addBalanceToTicketModal.amount;

    const closeWindow = () => {
        clearKeyboard();
        clearCustomer();
        hideAddBalanceToTicketModal();
    }

    const startPayment = () => {
        const paymentParam = JSON.stringify({
            SetPayment: addBalanceToTicketModal.paymentId,
            SetPaymentAmount: amount
        });

        hideAddBalanceToTicketModal();
        fastPayment(paymentParam, true);
    }

    return (
        <Modal className='addBalanceModal'
            contentLabel=""
            isOpen={addBalanceToTicketModal.show}
            style={properties.addBalanceModalStyle}>

            <div className="addBalanceModal_header">
                <div className="header_top">
                    <button className="header_close" onClick={closeWindow}>
                        <i className="icon remove" />
                        <Ink />
                    </button>
                </div>
            </div>
            <div className="addBalanceModal_content">
                <p>{getTranslation(resource.ADD_AMOUNT_TO_TICKET_BALANCE).format(amount)}</p>
                {customer && customer.customerid !== 0 ?
                    <div>{getTranslation(resource.CURRENT_BALANCE)}: &euro; {customer.customerSaldo}
                        <div>
                            <button className="btnPay" onClick={startPayment}>{getTranslation(resource.PAY)}</button>
                        </div>
                    </div>
                    : <ScanTicket />
                }
            </div>
            <div className="addBalanceModal_footer">
                <div className="btnLeft">
                    <button className="btnCancel" onClick={closeWindow} >
                        {getTranslation(resource.CANCEL)}
                    </button>
                </div>
            </div>
        </Modal>
    )
}

function mapStateToProps(state) {
    return {
        addBalanceToTicketModal: state.modalState.addBalanceToTicketModal,
        customer: state.receiptState.receipt.customer
    }
}

export default connect(mapStateToProps, {
    hideAddBalanceToTicketModal,
    getTranslation,
    clearKeyboard,
    clearCustomer,
    fastPayment
})(AddBalanceToTicketModal)


// WEBPACK FOOTER //
// src/modal/components/AddBalanceToTicketModal.jsx